'use client';
import Button from '@/components/ui/Button';

export default function PromotionalBannersSection() {
    return (
        <section className="w-full">
            <div className="w-full max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-[60px]">
                <div className="w-full max-w-[1804px] mx-auto grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-5 lg:gap-[30px]">
                    {/* Summer Sale Banner */}
                    <div className="relative overflow-hidden rounded-xl sm:rounded-2xl lg:rounded-[20px] h-[320px] sm:h-[360px] lg:h-[384px]">
                        <img
                            src="/images/img_image_2.png"
                            alt="Summer Sale"
                            className="w-full h-full object-cover"
                        />
                        <div className="absolute inset-0 flex flex-col justify-center items-start p-6 sm:p-8 lg:p-[35px]">
                            <p className="text-base sm:text-lg lg:text-xl text-text-on-dark font-semibold leading-5 sm:leading-6 lg:leading-xl mb-3 sm:mb-4 lg:mb-[14px]">
                                Summer Sale
                            </p>
                            <h3 className="text-3xl sm:text-4xl lg:text-7xl text-text-on-dark font-semibold leading-9 sm:leading-10 lg:leading-9xl mb-3 sm:mb-4 lg:mb-[16px]">
                                Up to<br />50% OFF
                            </h3>
                            <p className="text-base sm:text-lg lg:text-lg text-text-on-dark font-medium leading-5 sm:leading-6 lg:leading-md mb-5 sm:mb-6 lg:mb-[28px]">
                                Limited time offer!
                            </p>
                            <Button
                                className="bg-transparent border border-text-on-dark text-text-on-dark text-sm sm:text-base lg:text-base font-medium leading-base sm:leading-base lg:leading-base rounded-xs px-5 sm:px-6 lg:px-[26px] py-2.5 sm:py-3 lg:py-[12px] gap-[10px] hover:bg-text-on-dark hover:text-primary-brand transition-all duration-200"
                                border_border="border-text-on-dark"
                                layout_gap="gap-[10px]"
                                layout_width="w-auto"
                                padding="px-[26px] py-[12px]"
                                margin="mb-0"
                                position="relative"
                                variant="outline"
                                size="md"
                                onClick={() => { }}
                            >
                                Shop Sale
                                <img
                                    src="/images/img_arrowright.svg"
                                    alt=""
                                    className="w-3 h-3 sm:w-4 sm:h-4 lg:w-[16px] lg:h-[16px]"
                                />
                            </Button>
                        </div>
                    </div>

                    {/* New Arrivals Banner */}
                    <div className="relative overflow-hidden rounded-xl sm:rounded-2xl lg:rounded-[20px] h-[320px] sm:h-[360px] lg:h-[384px]">
                        <img
                            src="/images/img_image_1.png"
                            alt="New Arrivals"
                            className="w-full h-full object-cover"
                        />
                        <div className="absolute inset-0 flex flex-col justify-center items-start p-6 sm:p-8 lg:p-[35px] gap-4 sm:gap-5 lg:gap-[20px]">
                            <p className="text-base sm:text-lg lg:text-xl text-text-primary font-semibold leading-5 sm:leading-6 lg:leading-xl">
                                New Arrivals
                            </p>
                            <div className="flex flex-col gap-3 sm:gap-4 lg:gap-[16px]">
                                <h3 className="text-3xl sm:text-4xl lg:text-7xl text-text-primary font-bold leading-9 sm:leading-10 lg:leading-9xl">
                                    Just<br />Dropped!
                                </h3>
                                <p className="text-base sm:text-lg lg:text-lg text-text-primary font-medium leading-6 sm:leading-7 lg:leading-xl">
                                    Check out the latest<br />styles of the week.
                                </p>
                            </div>
                            <Button
                                className="bg-transparent border border-text-primary text-text-primary text-sm sm:text-base lg:text-base font-medium leading-base sm:leading-base lg:leading-base rounded-xs px-5 sm:px-6 lg:px-[26px] py-2.5 sm:py-3 lg:py-[12px] gap-[10px] hover:bg-text-primary hover:text-text-on-dark transition-all duration-200"
                                border_border="border-text-primary"
                                layout_gap="gap-[10px]"
                                layout_width="w-auto"
                                padding="px-[26px] py-[12px]"
                                margin="mb-0"
                                position="relative"
                                variant="outline"
                                size="md"
                                onClick={() => { }}
                            >
                                Explore Now
                                <img
                                    src="/images/img_arrowright_black_900.svg"
                                    alt=""
                                    className="w-3 h-3 sm:w-4 sm:h-4 lg:w-[16px] lg:h-[16px]"
                                />
                            </Button>
                        </div>
                    </div>

                    {/* Men's Collection Banner */}
                    <div className="relative overflow-hidden rounded-xl sm:rounded-2xl lg:rounded-[20px] h-[320px] sm:h-[360px] lg:h-[384px]">
                        <img
                            src="/images/img_image_3.png"
                            alt="Men's Collection"
                            className="w-full h-full object-cover"
                        />
                        <div className="absolute inset-0 flex flex-col justify-center items-start p-6 sm:p-8 lg:p-[36px] gap-5 sm:gap-6 lg:gap-[30px]">
                            <div className="flex flex-col gap-2 lg:gap-[8px]">
                                <h3 className="text-2xl sm:text-3xl lg:text-6xl text-text-primary font-semibold leading-7 sm:leading-8 lg:leading-8xl">
                                    Men&apos;s Collection
                                </h3>
                                <p className="text-base sm:text-lg lg:text-lg text-text-primary font-medium leading-6 sm:leading-7 lg:leading-4xl">
                                    Stylish, Comfortable,<br />Made for you.
                                </p>
                            </div>
                            <Button
                                className="bg-transparent border border-text-primary text-text-primary text-sm sm:text-base lg:text-base font-medium leading-base sm:leading-base lg:leading-base rounded-xs px-5 sm:px-6 lg:px-[26px] py-2.5 sm:py-3 lg:py-[12px] gap-2 hover:bg-text-primary hover:text-text-on-dark transition-all duration-200"
                                border_border="border-text-primary"
                                layout_gap="gap-2"
                                layout_width="w-auto"
                                padding="px-[26px] py-[12px]"
                                margin="mb-0"
                                position="relative"
                                variant="outline"
                                size="md"
                                onClick={() => { }}
                            >
                                Shop Now
                                <img
                                    src="/images/img_arrowright_black_900.svg"
                                    alt=""
                                    className="w-3 h-3 sm:w-4 sm:h-4 lg:w-[16px] lg:h-[16px]"
                                />
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}